import styled from "@emotion/styled";

import { setFullViewportWidthStyles } from "shared/lib/styles";

import { AppFooter } from "scmp-app/components/app-footer";

export const PageContainer = styled.div`
  ${setFullViewportWidthStyles()}
`;

export const StyledAppFooter = styled(AppFooter)`
  position: relative;

  margin-block-start: -150px;
  padding-block-start: 130px;

  background-color: #1b4191;
`;
